import { format } from "date-fns";
import { Link } from "react-router-dom";
import { useDeleteCampaignMutation } from '../campaignsApiSlice'


export default function CampaignRow({ campaign }) {
	const [deleteCampaign, { isLoading }] = useDeleteCampaignMutation();

  	const created = campaign.createdAt ? format(new Date(campaign.createdAt), "yyyy-MM-dd") : "—";

	const handleDelete = async () => {
		try {
			await deleteCampaign({ id: campaign._id }).unwrap()
			alert(`Campaign '${campaign.title}' deleted successfully`)
		} catch (err) {
			console.error("Delete error:", err)
			alert(err?.data?.message || "Failed to delete campaign")
		}
	}

	return (
		<tr className="hover:bg-gray-50/40">
			<td className="px-6 py-3 text-sm text-gray-900 font-medium">{campaign.title}</td>
			<td className="px-6 py-3 text-sm text-gray-600">{campaign.shortTitle || "—"}</td>
			{/* <td className="px-6 py-3 text-sm text-gray-600">
				{Array.isArray(campaign.roles) ? campaign.roles.map((r) => (
				<span key={r} className="mr-1 rounded-full bg-gray-100 px-2 py-0.5 text-xs text-gray-700 ring-1 ring-inset ring-gray-200">{r}</span>
				)) : campaign.roles || "—"}
			</td> */}
			<td className="px-6 py-3 text-sm text-gray-600">{campaign.startDate ? format(new Date(campaign.startDate), "yyyy-MM-dd") : "—"}</td>
			<td className="px-6 py-3 text-sm text-gray-600">{campaign.endDate ? format(new Date(campaign.endDate), "yyyy-MM-dd") : "—"}</td>
			<td className="px-6 py-3">
				{campaign.status === "open" ? (
				<span className="inline-flex items-center gap-1 rounded-full bg-emerald-50 px-2.5 py-1 text-xs font-medium text-emerald-700 ring-1 ring-inset ring-emerald-200">
					<span className="h-1.5 w-1.5 rounded-full bg-emerald-500"></span> open
				</span>
				) : (
				<span className="inline-flex items-center gap-1 rounded-full bg-rose-50 px-2.5 py-1 text-xs font-medium text-rose-700 ring-1 ring-inset ring-rose-200">
					<span className="h-1.5 w-1.5 rounded-full bg-rose-500"></span> closed
				</span>
				)}
			</td>
			<td className="px-6 py-3 text-sm text-gray-600">{created}</td>
			<td className="px-6 py-3 text-right">
				<div className="inline-flex gap-2">
				<Link
					to={`/dash/campaigns/${campaign._id}`}  
					className="rounded-xl border border-gray-200 bg-white px-3 py-1.5 text-xs text-gray-700 hover:bg-gray-50"
				>
					Edit
				</Link>
				<button
					onClick={handleDelete}
					disabled={isLoading}
					className="rounded-xl border border-gray-200 bg-white px-3 py-1.5 text-xs text-gray-700 hover:bg-gray-50"
				>
					{isLoading ? "Deleting..." : "Delete"}
				</button>
				</div>
			</td>
		</tr>
	);
}
